import React, { useState, useEffect, useRef } from 'react';

import { useForm } from 'react-hook-form';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Select from '@material-ui/core/Select';
import MenuItem from "@material-ui/core/MenuItem";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Button from '@material-ui/core/Button';
import Mascara from '../../../../shared/form/mascaras';
import Typography from "@material-ui/core/Typography";

import { FormControl, FormHelperText, FormLabel } from '@material-ui/core';

import moment from 'moment';

import { cadastrar, atualizar } from '../../../../../services/reuniao/ReuniaoService';

import { findCityById, findByCep } from '../../../../../services/cep/CepService';

import UseStyles from '../../../useStyles';

import { useSnackbar } from 'notistack';
import { getConselhos } from "../../../../../services/usuario/ConselhoService";

const periodicidadeItens = [
  { valor: 'ORDINARIA', nome: 'Ordinária' },
  { valor: 'EXTRAORDINARIA', nome: 'Extraordinária' }
].map((item) => (
  <MenuItem key={item.valor} value={item.valor}>{item.nome}</MenuItem>
));

const relacaoUf = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "SãoPaulo",
  SE: "Sergipe",
  TO: "Tocantins",
}

const ReuniaoAbaSobre = (props) => {

  const classes = UseStyles();
  const [cidades, setCidades] = useState(null);

  const { register, handleSubmit, errors, setValue, clearError } = useForm();

  const { enqueueSnackbar } = useSnackbar();

  const { handleStepper, dados, updateDados, history } = props;

  //formato para API do IBGE
  const estadosIBGE = [
    { "id": 11, "nome": "Rondônia" },
    { "id": 12, "nome": "Acre" },
    { "id": 13, "nome": "Amazonas" },
    { "id": 14, "nome": "Roraima" },
    { "id": 15, "nome": "Pará" },
    { "id": 16, "nome": "Amapá" },
    { "id": 17, "nome": "Tocantins" },
    { "id": 21, "nome": "Maranhão" },
    { "id": 22, "nome": "Piauí" },
    { "id": 23, "nome": "Ceará" },
    { "id": 24, "nome": "Rio Grande do Norte" },
    { "id": 25, "nome": "Paraíba" },
    { "id": 26, "nome": "Pernambuco" },
    { "id": 27, "nome": "Alagoas" },
    { "id": 28, "nome": "Sergipe" },
    { "id": 29, "nome": "Bahia" },
    { "id": 31, "nome": "Minas Gerais" },
    { "id": 32, "nome": "Espírito Santo" },
    { "id": 33, "nome": "Rio de Janeiro" },
    { "id": 35, "nome": "São Paulo" },
    { "id": 41, "nome": "Paraná" },
    { "id": 42, "nome": "Santa Catarina" },
    { "id": 43, "nome": "Rio Grande do Sul" },
    { "id": 50, "nome": "Mato Grosso do Sul" },
    { "id": 51, "nome": "Mato Grosso" },
    { "id": 52, "nome": "Goiás" },
    { "id": 53, "nome": "Distrito Federal" }
  ].sort((a, b) => {
    if (a.nome < b.nome) {
      return -1;
    } else if (a.nome > b.nome) {
      return 1;
    }
    return 0;
  }).map((item) => (
    <MenuItem id={item.id} key={item.id} value={item.nome}>{item.nome}</MenuItem>
  ));


  const [conselhos, setConselhos] = useState([]);

  const conselhoItens = conselhos.map((item, key) => (
    <MenuItem key={key} value={item.id}>{item.descricao}</MenuItem>
  ));

  useEffect(() => {
    register({ name: 'periodicidade' }, { required: 'Periodicidade é obrigatória' });
    register({ name: 'conselho' }, { required: 'Conselho é obrigatório' });
    register({ name: 'estado' }, { required: 'Estado é obrigatório' });
    register({ name: 'cidade' }, { required: 'Cidade é obrigatória' });
    register({ name: 'data' }, { required: 'Data é obrigatória' })
    register({ name: 'hora' }, { required: 'Hora é obrigatória' })
    register({ name: 'cep' }, { required: 'CEP é obrigatório' })
    register({ name: 'endereco' }, { required: 'Endereço é obrigatório' })
    register({ name: 'descricao' }, { required: 'Descrição é obrigatória' })
    setValue('edicao', dados.edicao);
    setValue('periodicidade', dados.periodicidade);
    setValue('conselho', dados.conselho);
    setValue('data', dados.data);
    setValue('hora', dados.hora);
    setValue('cep', dados.cep);
    setValue('estado', dados.estado.nome);
    setValue('cidade', dados.cidade);
    setValue('endereco', dados.endereco);
    setValue('descricao', dados.descricao);
    clearError();
  }, [dados]);

  useEffect(() => {
    getConselhos().then((response) => setConselhos(response.data));
  }, []);

  const [finalize, setFinalize] = useState(false);

  const buscarCidade = async (nomeEstado) => {
    setCidades([]);
    updateDados({ ...dados, cidade: '' });
    let cidadesAux = [];
    let id = null;
    for (let estado of estadosIBGE) {
      if (estado.props.value === nomeEstado) {
        id = estado.props.id;
        break;
      }
    };
    if (id) {
      const response = await findCityById(id);
      if (!response) {
        setCidades([]);
        return;
      }
      const { data } = response;
      data.map((item) => {
        cidadesAux.push(item.nome);
      })
    }
    setCidades(cidadesAux.map((item, key) => (
      <MenuItem selected={dados.cidade === item.toUpperCase()} key={item + key + ''} value={item.toUpperCase()}>{item.toUpperCase()}</MenuItem>
    )));
  }

  const buscarPorCep = async () => {
    if (!dados.cep) {
      return;
    }
    const cepTratado = dados.cep.replace(/\D/g, "");
    if (cepTratado.length !== 8) {
      let estado = { id: null, nome: '' }
      updateDados({ ...dados, cidade: '', endereco: '', estado });
      return;
    }
    const response = await findByCep(cepTratado);
    if (response && response.status === 200) {
      const data = response.data;
      for (let estados of estadosIBGE) {
        if (relacaoUf[data.uf] === estados.props.value) {
          let estado = { id: estados.key, nome: estados.props.value }
          await buscarCidade(estados.props.value);
          updateDados({ ...dados, cidade: data.localidade, endereco: data.logradouro, estado });
          setValue('estado', estado.nome);
          clearError('estado');
        }
      }
      setValue('cidade', data.cidade);
      clearError('cidade');
      setValue('endereco', data.logradouro);
      clearError('endereco');

      if (data.erro) {
        let estado = { id: null, nome: '' }
        updateDados({ ...dados, cidade: '', endereco: '', estado });
        enqueueSnackbar('O CEP informado não existe', { variant: 'error' });
      }
    }
  }

  const submit = () => {
    let data = moment(dados.data + ' ' + dados.hora, 'DD/MM/YYYY HH:mm');
    if (data > moment()) {
      const reuniao = {
        idConselho: dados.conselho,
        edicao: dados.edicao,
        periodicidade: dados.periodicidade,
        data: data.format('YYYY-MM-DDTHH:mm:ss'),
        descricao: dados.descricao,
        cep: dados.cep.replace('-', ''),
        estado: dados.estado.nome,
        cidade: dados.cidade,
        endereco: dados.endereco
      };

      if (dados.id) {
        reuniao.id = dados.id;
        atualizar(reuniao).then((response) => {
          if (response && response.status === 200) {
            updateDados({ ...dados, id: response.data.id });
            if (!finalize) {
              handleStepper(1)
            } else {
              history.push(`/reuniao/${dados.id}/visualizar`);
            }
          }
        });
      }

      cadastrar(reuniao).then((response) => {
        if (response && response.status === 200) {
          updateDados({ ...dados, id: response.data.id });
          handleStepper(1)
        }
      });
    } else {
      enqueueSnackbar('Informe uma data válida', { variant: 'error' });
    }

  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'estado') {
      let estadoSelecionado = {};
      for (let estado of estadosIBGE) {
        if (estado.props.value === value) {
          estadoSelecionado = { ...estado.props };
          break;
        }
      };
      setValue(name, estadoSelecionado.value, true);
      updateDados({ ...dados, [name]: { id: estadoSelecionado.id, nome: estadoSelecionado.value }, endereco: '' });
    } else if (name === 'cidade') {
      let cidadeSelecionada = '';
      for (let cidade of cidades) {
        if (cidade.props.value === value) {
          cidadeSelecionada = value;
          break;
        }
      };
      setValue(name, cidadeSelecionada, true);
      updateDados({ ...dados, [name]: cidadeSelecionada });
    } else {
      setValue(name, value, true);
      updateDados({ ...dados, [name]: value });
    }
  };

  const isEditar = window.location.pathname.includes('editar');

  const handleFinalize = () => {
    setFinalize(true);
  }


  return (
    <>
      <form onSubmit={handleSubmit(submit)} style={{ marginTop: 100 }}>
        <div style={{ padding: 24, marginTop: 24, paddingTop: 48 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography className={classes.tituloAba}>Sobre</Typography>
            {isEditar &&
              <div style={{ display: 'flex', gap: 8 }}>
                <Button type="submit" onClick={handleFinalize} variant="contained" >Finalizar</Button>
                <Button type="submit" variant="contained" >Próximo</Button>
              </div>}
          </div>
          <Grid container spacing={2} style={{ marginTop: 24 }} >
            <Grid item sm={6} xs={12}>
              <Grid container spacing={2}>
                <Grid style={{ position: 'relative', paddingTop: 28 }} item md={6} sm={12} xs={5}>
                  <TextField
                    id="edicao"
                    name="edicao"
                    variant="outlined"
                    autoFocus
                    type="number"
                    fullWidth
                    value={dados.edicao}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: 'true' }}
                    label="Edição da reunião" />
                  <div onClick={() => updateDados({ ...dados, edicao: parseInt(dados.edicao) + 1 })} className={classes.reunioesAddButon}><ExpandLessIcon style={{ position: 'absolute' }} /></div>
                  <div onClick={() => updateDados({ ...dados, edicao: parseInt(dados.edicao) - 1 })} className={classes.reunioesSubButon}><ExpandMoreIcon style={{ position: 'absolute' }} /></div>
                </Grid>
                <Grid item md={6} sm={12} xs={7}>
                  <FormControl fullWidth error={!!errors.periodicidade}>
                    <FormLabel shrink id="reuniaoPeriodicidade">Periodicidade</FormLabel>
                    <Select
                      id="periodicidade"
                      name="periodicidade"
                      variant="outlined"
                      value={dados.periodicidade}
                      onChange={handleChange}
                      labelId="reuniaoPeriodicidade"
                      InputLabelProps={{ shrink: 'true' }}
                      IconComponent={ExpandMoreIcon}
                      fullWidth >
                      {periodicidadeItens}
                    </Select>
                    <FormHelperText>{errors.periodicidade && errors.periodicidade.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <FormControl fullWidth error={!!errors.conselho}>
                    <FormLabel shrink id="reuniaoComite">Conselho/Comissão/Comitê</FormLabel>
                    <Select
                      name="conselho"
                      id="conselho"
                      variant="outlined"
                      value={dados.conselho}
                      onChange={handleChange}
                      labelId="reuniaoComite"
                      InputLabelProps={{ shrink: 'true' }}
                      IconComponent={ExpandMoreIcon}
                      fullWidth >
                      {conselhoItens}
                    </Select>
                    <FormHelperText>{errors.conselho && errors.conselho.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid style={{ paddingTop: 28 }} item md={4} sm={6} xs={6}>
                  <TextField
                    id='data'
                    name='data'
                    variant="outlined"
                    value={dados.data}
                    onChange={handleChange}
                    fullWidth
                    InputProps={{
                      inputComponent: Mascara.data,
                    }}
                    InputLabelProps={{ shrink: 'true' }}
                    label="Data"
                    error={!!errors.data}
                    helperText={errors.data && errors.data.message}
                  />
                </Grid>
                <Grid style={{ paddingTop: 28 }} item md={2} sm={6} xs={6}>
                  <TextField
                    id='hora'
                    name='hora'
                    value={dados.hora}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      inputComponent: Mascara.hora,
                    }}
                    InputLabelProps={{ shrink: 'true' }}
                    label="Hora"
                    error={!!errors.hora}
                    helperText={errors.hora && errors.hora.message}
                  />
                </Grid>
                <Grid style={{ paddingTop: 28 }} item md={6} sm={12} xs={12}>
                  <TextField
                    id='cep'
                    name='cep'
                    fullWidth
                    variant="outlined"
                    value={dados.cep}
                    onChange={handleChange}
                    onBlur={buscarPorCep}
                    InputProps={{
                      inputComponent: Mascara.cep,
                      inputComponent: Mascara.cep,
                    }}
                    InputLabelProps={{ shrink: 'true' }}
                    label="CEP"
                    error={!!errors.cep}
                    helperText={errors.cep && errors.cep.message}
                  />
                </Grid>
                <Grid item md={6} sm={12} xs={6}>
                  <FormControl fullWidth error={!!errors.estado}>
                    <FormLabel shrink id="reuniaoEstado">Estado</FormLabel>
                    <Select
                      id="estado"
                      name="estado"
                      value={dados.estado?.nome || ''}
                      variant="outlined"
                      renderValue={(value) => {
                        return value;
                      }}
                      onChange={(e) => {
                        buscarCidade(e.target.value);
                        handleChange(e);
                      }}
                      disabled
                      labelId="reuniaoEstado"
                      InputLabelProps={{ shrink: 'true' }}
                      IconComponent={ExpandMoreIcon}
                      fullWidth >
                      {estadosIBGE}
                    </Select>
                    <FormHelperText>{errors.estado?.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={6} sm={12} xs={6}>
                  <FormControl fullWidth error={!!errors.cidade}>
                    <FormLabel shrink id="reuniaoCidade">Cidade</FormLabel>
                    <Select
                      disabled
                      id="cidade"
                      name="cidade"
                      variant="outlined"
                      value={dados.cidade?.toUpperCase() ?? ''}
                      onChange={handleChange}
                      labelId="reuniaoCidade"
                      InputLabelProps={{ shrink: 'true' }}
                      placeholder={dados.cidade?.nome ?? ''}
                      IconComponent={ExpandMoreIcon}
                      fullWidth >
                      {(!cidades && dados.cidade) && <MenuItem selected value={dados.cidade.toUpperCase()}>{dados.cidade}</MenuItem>}
                      {cidades}
                    </Select>
                    <FormHelperText>{errors.cidade && errors.cidade.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid style={{ paddingTop: 28 }} item md={6} sm={12} xs={12}>
                  <TextField
                    id='endereco'
                    name='endereco'
                    variant="outlined"
                    value={dados.endereco}
                    onChange={handleChange}
                    fullWidth
                    InputLabelProps={{ shrink: 'true' }}
                    label="Endereço e local"
                    error={!!errors.endereco}
                    helperText={errors.endereco && errors.endereco.message}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Grid style={{ paddingTop: 20 }} container spacing={2}>
                <Grid sytle={{ position: 'relative', }} item sm={12} xs={12}>
                  <TextField
                    error={dados.descricao.length > 380}
                    variant="outlined"
                    fullWidth
                    name='descricao'
                    id="descricao"
                    rows="9"
                    multiline
                    value={dados.descricao}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: 'true' }}
                    label="Descrição da reunião"
                    error={!!errors.descricao}
                    helperText={errors.descricao && errors.descricao.message}
                  />
                  <div style={{ position: 'relative', top: -10, display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#5e6784' }}>
                    <p>Máximo de 380 caractéres</p>
                    <p>{dados.descricao.length} de 380</p>
                  </div>
                </Grid>
              </Grid>
              {!isEditar && <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="submit" variant="contained" size="small">Próximo</Button>
              </div>}
            </Grid>
          </Grid>
        </div>
      </form>
    </>
  );
}

export default ReuniaoAbaSobre;
